const Auth = {
  mandatorySignId: true,
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  // Store Cognito tokens in a cookie instead of Local Storage (NetSPI finding -
  // tokens in Local Storage persist after the browser closes and are readable by
  // any script). Keeps users logged in on refresh, same as before.
  cookieStorage: {
    // domain is required by this Amplify version - use the current hostname so it
    // works the same locally and in every deployed env without hardcoding one
    domain: window.location.hostname,
    path: '/',
    expires: 1, // days - matches the Cognito app client's refresh token validity
    secure: true,
    sameSite: 'strict' as const
  }
};

export default Auth;
